import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './school-portal.css';
import './app.css';
import { getInitialHoverZoomOthers, syncHoverZoomOthersToDom } from './accessibility/a11yPreferences';
import App from './app';

syncHoverZoomOthersToDom(getInitialHoverZoomOthers());
import Register from './Register';
import RenewalUpgradePage from './RenewalUpgradePage';
import AccreditationWizardPage from './AccreditationWizardPage';
import AdminPortal from './admin/AdminPortal'; // Ensure this path is correct

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* The Admin Hub - Added /* to ensure it matches precisely */}
        <Route path="/admin/*" element={<AdminPortal />} />

        {/* The Public Signup Form */}
        <Route path="/register" element={<Register />} />

        <Route path="/accreditation-wizard" element={<AccreditationWizardPage />} />

        {/* Existing school: renewal / upgrade (full page) */}
        <Route path="/renewal" element={<RenewalUpgradePage />} />

        {/* The Main School Portal */}
        <Route path="/" element={<App />} />

        {/* Optional: Catch-all for 404s to send them back to the portal */}
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);